import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { catchError, retry } from 'rxjs/operators';

import { ENPOINT } from '../endpoint';
import { Options } from 'selenium-webdriver/safari';

import { GLOBAL } from '../global';

@Injectable()
export class EMService {
  constructor(
    private http: HttpClient,
    
  ) { }
  public url = GLOBAL.url;
  private basePath = ENPOINT.url;


  obtenerOrdenesCompra(userProveedorId, iPagina): Observable<any> {
    const num_proveedor = userProveedorId;
    const pagina = iPagina;
    const dias_atras = '100';
    const tipo_de_operacion = 'E';

    const httpHeaders = new HttpHeaders();
    const options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
      .set('num_proveedor', num_proveedor)
      .set('pagina', pagina)
      .set('dias_atras', dias_atras)
      .set('tipo_de_operacion', tipo_de_operacion)
    };
    return this.http.get(this.basePath + 'Proveedores-facturas/OrdenesDeCompra', options);
  }

  buscarOrdenesCompra(userProveedorId, iPagina): Observable<any> {
    const num_proveedor = userProveedorId;
    const pagina = iPagina;
    const dias_atras = '100';
    const tipo_de_operacion = 'E';

    const httpHeaders = new HttpHeaders();
    const options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
      .set('num_proveedor', num_proveedor)
      .set('pagina', pagina)
      .set('dias_atras', dias_atras)
      .set('tipo_de_operacion', tipo_de_operacion)
    };
    return this.http.get(this.basePath + 'Proveedores-facturas/OrdenesDeCompra', options);
  }

  busquedaOrdenesCompra(proveedor, ordenCompra, sociedadOpc): Observable<any> {

    const httpHeaders = new HttpHeaders();
    const options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
      .set('num_proveedor', proveedor)
      .set('orden_de_compra', ordenCompra)
      .set('referencia', '')
      .set('sociedad', sociedadOpc)
      .set('tipo_de_operacion', 'E')
    };
    return this.http.get(this.basePath + 'Proveedores-facturas/OrdenesDeCompra', options);
  }

  obtenerEntradasMercancia(num_pedido, proveedor, tipo): Observable<any> {
    const httpHeaders = new HttpHeaders();
    const options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
      .set('entradas', num_pedido)
      .set('tipo_op', tipo)
      .set('wo_em', '')
      .set('proveedor', proveedor)
    };
     return this.http.get(this.basePath +
     'orden-compra/entradas', options);
  }

  guardarFacturaOC(identificadorDeLlamada, fd, cfdi): Observable<any> {
    const params = fd;
    const checkCFDI = cfdi;
    // tslint:disable-next-line:max-line-length
    const httpHeaders = new HttpHeaders().set('Accept', 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8');
    const options = {
      headers: httpHeaders,
      withCredentials: true
    };
    return this.http.post(this.basePath + 'Proveedores-facturas/guardarFacturaOC' + identificadorDeLlamada +
     '&sinCfdi=' + checkCFDI, params, options);
  }

  enviarFactura(formData): Observable<any> {
    const params = formData;
    // tslint:disable-next-line:max-line-length
    const httpHeaders = new HttpHeaders().set('Accept', 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8');
    const options = {
      headers: httpHeaders,
      withCredentials: true
    };
    return this.http.post(this.basePath + 'orden-compra/carga-ordenes', params, options);
  }


 //POST cargar zip carga masiva con OC
 postCargaZIP(batch, zip, tipo): Observable<any> {
    
  // tslint:disable-next-line:max-line-length
  const httpHeaders = new HttpHeaders()
  const options = {
    headers: httpHeaders,
    withCredentials: true,
    params: new HttpParams()
    .set('conOrdenCompra', tipo)
  };

  return this.http.post(this.basePath + 'facturas-batch/uploadZip/'+batch, zip, options);
}
}



// WEBPACK FOOTER //
// ./src/app/services/invoices-em/em.service.ts